import { c as _c } from "react/compiler-runtime";
import { type AITool } from "@app/_metadata";
import LEOLogo from "@shared-assets/leo-logo.svg";
import { Badge } from "@shared-components/shadcn/badge";
import { api } from "@shared-server/api";
import { cn } from "@shared-utils/ui";
import Image from "next/image";

/**
 * LEO Ident used in TopBar and auth prompt
 *
 * @param props IdentProps
 */

interface IdentProps {
  invert?: boolean;
  aiTool?: AITool;
}
export const Ident = props => {
  const $ = _c(16);
  const envQuery = api.utils.env.useQuery();
  const env = envQuery.data;
  let t0;
  if ($[0] !== props.invert) {
    t0 = cn("mr-4 flex flex-row justify-start", {
      "text-gray-200": props.invert
    });
    $[0] = props.invert;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.invert) {
    t1 = cn("mr-3 w-[40px] dark:invert", {
      invert: props.invert
    });
    $[2] = props.invert;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <Image priority={false} className={t1} src={LEOLogo as string} alt="LEO logo" />;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="-mb-1 text-xs font-extrabold font-heading mt-1 whitespace-nowrap">{"LEO Pharma"}</div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = props.aiTool?.meta.name || "LEO AI";
  let t5;
  if ($[7] !== env) {
    t5 = env && env !== "prod" && <Badge size="sm" className={cn("mx-2 hidden text-white md:inline-block", {
      "bg-ter-yellow-600": env === "test",
      "bg-ter-mint-500": env === "dev",
      "bg-slate-500": env === "local"
    })}>{env.toUpperCase()}</Badge>;
    $[7] = env;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div data-dd-privacy="allow">{t3}<span className="text-lg whitespace-nowrap inline-block font-heading">{t4}{t5}</span></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t0 || $[13] !== t2 || $[14] !== t6) {
    t7 = <div className={t0}>{t2}{t6}</div>;
    $[12] = t0;
    $[13] = t2;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};